import { NewsItem } from '~/types/media'

import MediaNewsItem from './MediaNewsItem'

export default function MediaNewsList({ news }: { news: NewsItem[] }): React.ReactElement {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {news.map((item) => (
        <MediaNewsItem key={item._id} {...item} />
      ))}
    </div>
  )
}
